import { Container, Grid } from '@mui/material';
import { useRouter } from 'next/router';
import getConfig from 'next/config';
import React, { useContext, useEffect, useState } from 'react';
import { useTheme } from '@mui/material/styles';
import { ArrowBack, ArrowForward } from '@mui/icons-material';
import { useApolloClient } from '@apollo/client';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import EirHandsetContainer from '../../../../components/eir-handset-details/EirHandsetContainer';
import NavBar from '../../../../components/eir-nav-bar/NavBar';
import getStrapiData from '../../../../integration/strapi';
import {
  onOfferCardSelected,
  onOfferCardUnSelected,
  mobileHandsetDetailsOnLoad,
} from '../../../../components/eir-mobile-offer-container/mobile.util';
import { useToggle } from '../../../../hooks/useToggle';
import RootContext from '../../../../../util/root.context';
import ErrorModal from '../../../../components/eir-error-modal/ErrorModal';
import { displayCart } from '../../../../components/eir-cart/cart.util';
import useLocalStorage, { getLocalStorage, setCode } from '../../../../hooks/useLocalStorage';
import { onPortingChangeService } from '../../../../components/eir-mobile-offer-container/standalonedevice.util';
import { addToCartAnalytics, removeFromCartAnalytics } from '../../../../../util/gtm';
import validateCart from '../../../../components/shared/validateCart';
import { mobileEligibilityCheck } from '../../../../components/shared/eligibilityCheck';
import { getCookie, getTokenFromCookies, setCookie } from '../../../../hooks/useCookie';
import getStrapiCollectionData from '../../../../integration/strapi.client';
import getGeneralImage from '../../../../../util/getGeneralImage';
import ApiFailureModal from '../../../../components/eir-error-modal/ApiFailureModal';
import EirMetaTag from '../../../../components/eir-meta-tag/EirMetaTag';
import FaqContainer from '../../../../components/eir-mobile-broadband/FaqContainer';
import styles from '../../../../components/eir-handset-details/styles';
import EirHeader from '../../../../components/eir-header/EirHeader';
import EirFooter from '../../../../components/eir-footer/EirFooter';
import LoginMain403 from '../../../../components/eir-403-login/LoginMain403';
import SessionExpireModal from '../../../../components/eir-session-expire-modal/sessionExpireModal';

export async function getServerSideProps({ req }) {
  const cmsData = await getStrapiData('handset');
  let eligibility = {};
  let journeyData = {};
  let cmsHeaderData = {};
  let cmsFooterData = {};
  let error = '';
  try {
    journeyData = await validateCart(req.cookies);
    cmsHeaderData = await getStrapiData('header');
    cmsFooterData = await getStrapiData('footer');
    if (journeyData.token) {
      eligibility = await mobileEligibilityCheck({ token: journeyData.token });
      eligibility = JSON.stringify(eligibility);
    }
  } catch (err) {
    eligibility = JSON.stringify(eligibility);
    error = err.message;
  }

  return {
    props: {
      cmsData,
      eligibility,
      cmsHeaderData,
      cmsFooterData,
      journeyData,
      error,
    },
  };
}

export const fetchInfo = async () => {
  try {
    const res = await getStrapiCollectionData('eir-action-modals', 'Error try again');

    return res;
  } catch (error) {
    console.error('error', error);
  }
};

const MobileDevice = ({ cmsData, journeyData, cmsHeaderData, cmsFooterData }) => {
  const [showLoader, setShowLoader] = useState({ code: ' ', value: false });
  const [addingTariff, setAddingTariff] = useState(false);
  const router = useRouter();
  const { publicRuntimeConfig } = getConfig();
  const theme = useTheme();
  const showModal = useToggle(false);
  const showSessionExpiredModal = useToggle(false);
  const [title, setTitle] = useState(router.query.title);
  const [loading, setLoading] = useState({ offerData: true });
  const [state, setState] = useState({
    offers: [],
    discounts: [],
    selectedOfferId: null,
    selectedMobileOffer: null,
    simOnly: false,
  });
  const graphql = useApolloClient();
  const openAPIFailureModal = useToggle(false);
  const [openError, setOpenError] = useState(false);
  const [errorModalOccurence, setErrorModalOccurence] = useState(0);
  const errorModalMaxOccurence = 1;
  const errorModal = useToggle(false);
  const [onLoadError, setOnLoadError] = useState(false);
  const { state: rootState, dispatch } = useContext(RootContext);
  const localStore = useLocalStorage();
  const [handsetCode, setHandsetCode] = useState('');
  const [handsetNotFound, setHandsetNotFound] = useState(false);
  const [mobileOffersIncart, setMobileOffersIncart] = useState(0);
  const [coUpgradeButton, setCoUpgradeButton] = useState(false);
  const [showInsurance, setShowInsurance] = useState(false);

  useEffect(() => {
    if (journeyData?.cartType === 'CROSS_SELL') {
      setCode('CS');
      if (getTokenFromCookies()?.length > 0) {
        dispatch({
          type: 'LOGIN',
          payload: { email: getCookie('email_Address') },
        });
      }
    }
    if (journeyData?.cartType === 'CHANGE_OFFER') {
      setCode('CO');
    }
  }, []);

  useEffect(() => {
    const localRepoItems = getCookie('found-403');
    if (localRepoItems === 'true') {
      showModal.enable();
    } else {
      showModal.disable();
    }
    const expiredRepoItems = getCookie('token-missing');
    if (expiredRepoItems === 'true') {
      showSessionExpiredModal.enable();
    } else {
      showSessionExpiredModal.disable();
    }
  });

  const handleOk = () => {
    openAPIFailureModal.disable();
  };

  /* Standalone Handset flow */
  const onPortingChange = async (portIn, tempHandsetCode) => {
    setLoading({ ...loading, offerData: true });
    setState({ ...state, offers: [] });
    const handsetCodeNew = tempHandsetCode || handsetCode;
    const offerData = await onPortingChangeService({ graphql, portIn, handsetCodeNew });
    setState({ ...state, offers: offerData?.offers, discounts: offerData?.discounts });
    setLoading({ ...loading, offerData: false });
  };

  const onOfferUnSelect = async () => {
    try {
      const data = await onOfferCardUnSelected({
        graphql,
        localStorage: localStore,
        cart: rootState.cart,
      });
      if (data != null && !data.error) {
        removeFromCartAnalytics(data);
        dispatch({ type: 'SET_CART', payload: data });
        displayCart({
          dispatch,
          localStorage: localStore,
          graphql,
          cart: data,
          showNextButton: false,
        });
        setState({
          ...state,
          selectedMobileOffer: null,
        });
        setErrorModalOccurence(0);
        errorModal.disable();
        setOnLoadError(false);
      } else {
        setOnLoadError(false);
        if (!getCookie('token-missing') && !getCookie('found-403')) setOpenError(true);
        setCookie('ION', 'API_FAILED', 'onOfferUnSelect');
        if (!getCookie('token-missing') && !getCookie('found-403')) openAPIFailureModal.enable();
        if (!getCookie('token-missing') && !getCookie('found-403'))
          setErrorModalOccurence(errorModalOccurence + 1);
        if (!getCookie('found-403')) errorModal.enable();
        if (!getCookie('token-missing')) errorModal.enable();
        setShowLoader(' ');
      }

      return data;
    } catch (err) {
      setOnLoadError(false);
      if (!getCookie('token-missing') && !getCookie('found-403')) setOpenError(true);
      if (!getCookie('token-missing') && !getCookie('found-403'))
        setErrorModalOccurence(errorModalOccurence + 1);
      if (!getCookie('found-403')) errorModal.enable();
      if (!getCookie('token-missing')) errorModal.enable();
      setCookie('ION', 'API_FAILED', 'onOfferUnSelect');
      if (!getCookie('token-missing') && !getCookie('found-403')) openAPIFailureModal.enable();
      setShowLoader(' ');
    }
  };

  // on Offer Select
  const onOfferSelect = async (tariff, simOnly) => {
    if (!addingTariff) {
      setShowLoader(tariff.code);
      setAddingTariff(true);
      setLoading({ ...loading, deviceData: true });
      try {
        const data = await onOfferCardSelected({
          graphql,
          selectedOffer: tariff,
          localStorage: localStore,
          cart: rootState.cart,
        });

        if (data != null && !data.error) {
          addToCartAnalytics(data);
          localStore.removeLocalStorage('INCOMPLETE_CART');
          dispatch({ type: 'SET_CART', payload: data });
          if (!getLocalStorage('STANDALONE_HANDSET')) {
            displayCart({
              dispatch,
              localStorage: localStore,
              graphql,
              // nextMethod: nextButtonAction,
              disablenNextButton: !simOnly,
              showNextButton: false,
              cart: data,
            });
          }
          setShowLoader(' ');
          setState({ ...state, selectedOfferId: data.offers });
          setErrorModalOccurence(0);
          errorModal.disable();
          setAddingTariff(false);
          setCoUpgradeButton(false);
        } else {
          setAddingTariff(false);
          if (!getCookie('token-missing') && !getCookie('found-403')) setOpenError(true);
          setOnLoadError(false);
          if (!getCookie('token-missing') && !getCookie('found-403')) openAPIFailureModal.enable();
          setShowLoader(' ');
          if (!getCookie('token-missing') && !getCookie('found-403'))
            setErrorModalOccurence(errorModalOccurence + 1);
          if (!getCookie('found-403')) errorModal.enable();
          if (!getCookie('token-missing')) errorModal.enable();
        }
        setLoading({ ...loading, deviceData: false });
      } catch (err) {
        setAddingTariff(false);
        if (!getCookie('token-missing') && !getCookie('found-403')) setOpenError(true);
        setOnLoadError(false);
        setCookie('ION', 'API_FAILED', 'onOfferSelect');
        if (!getCookie('token-missing') && !getCookie('found-403')) openAPIFailureModal.enable();
        setShowLoader(' ');
        if (!getCookie('token-missing') && !getCookie('found-403'))
          setErrorModalOccurence(errorModalOccurence + 1);
        if (!getCookie('found-403')) errorModal.enable();
        if (!getCookie('token-missing')) errorModal.enable();
        if (!getCookie('token-missing') && !getCookie('found-403')) openAPIFailureModal.enable();
        setShowLoader(' ');
      }
    }
  };

  const onPageLoad = async mobileHandsetCode => {
    if (!localStore.getLocalStorage('STANDALONE_HANDSET'))
      localStore.setLocalStorage('INCOMPLETE_CART', true);
    else {
      const { offers, selectedMobileOffer, discounts } = await mobileHandsetDetailsOnLoad({
        graphql,
        localStorage: localStore,
        dispatch,
        mobileHandsetCode,
      });
      if (!offers) {
        setOnLoadError(true);
        if (!getCookie('token-missing') && !getCookie('found-403')) setOpenError(true);
        if (!getCookie('token-missing') && !getCookie('found-403'))
          setErrorModalOccurence(errorModalOccurence + 1);
        if (!getCookie('found-403')) errorModal.enable();
        if (!getCookie('token-missing')) errorModal.enable();
        if (!getCookie('token-missing') && !getCookie('found-403')) openAPIFailureModal.enable();
      } else {
        setLoading({ ...loading, offerData: true });
        setState({
          ...state,
          offers,
          discounts,
          selectedMobileOffer: selectedMobileOffer?.offer,
        });
        setLoading({ ...loading, offerData: false });
      }
    }
  };

  const onPageLoadWhenVarientChanges = async mobileHandsetCode => {
    const { offers, selectedMobileOffer, discounts } = await mobileHandsetDetailsOnLoad({
      graphql,
      localStorage: localStore,
      dispatch,
      mobileHandsetCode,
    });
    if (offers) {
      setState({
        ...state,
        offers,
        discounts,
        selectedMobileOffer: selectedMobileOffer?.offer,
      });
      if (
        selectedMobileOffer?.offer &&
        getLocalStorage('HANDSET_BE_OFFERID') &&
        getLocalStorage('STANDALONE_HANDSET')
      ) {
        setCoUpgradeButton(true);
      }
      setLoading({ ...loading, offerData: false });
    }
  };
  useEffect(() => {
    setTitle(router.query.title);
    setShowLoader(true);
    setMobileOffersIncart(
      rootState?.cart?.offers?.filter(offer => offer?.equipments?.length > 0).length
    );
  }, [router.query.title]);
  const backStep = async () => {
    if (getLocalStorage('STANDALONE_HANDSET')) {
      // router.push(`${publicRuntimeConfig.NEXT_PUBLIC_PATH}/mobile/handsets`);
      window.location.href = `${publicRuntimeConfig.NEXT_PUBLIC_PATH}/mobile/handsets`;
    } else {
      dispatch({ type: 'SET_BILLPAY_TOGGLE', payload: true });
      localStore.setLocalStorage('BILLPAY_JOURNEY', true);
      router.push(`${publicRuntimeConfig.NEXT_PUBLIC_PATH}/mobile`);
    }
  };

  return (
    <>
      <EirHeader cmsHeaderData={cmsHeaderData?.data} />
      <main id='main' tabIndex={-1}>
        {!handsetNotFound && (
          <NavBar
            forwardArrowIcon={
              <ArrowForward sx={{ m: 0, color: theme.palette.secondary.contrastText }} />
            }
            backArrowIcon={<ArrowBack sx={{ m: 0, color: theme.palette.secondary.contrastText }} />}
            backButtonText='Back'
            forwardButtonText='Checkout'
            headerText='2-3 day delivery after order completion'
            headerIcon={
              <LocalShippingIcon
                sx={{ color: theme.palette.primary.contrastText, mr: 1, fontSize: '1rem' }}
              />
            }
            backButtonOnClick={() => {
              backStep();
            }}
            nextButtonOnClick={() => {}}
            disableBack={false}
            // buttonPositionToLeft
            disableNext
          />
        )}

        <EirMetaTag seo={cmsData?.data?.attributes?.Seo_Handset} />

        <Container
          maxWidth='100%'
          sx={{
            background:
              handsetNotFound &&
              `url(${publicRuntimeConfig.NEXT_PUBLIC_STRAPI}${
                getGeneralImage({
                  generalImageArray: cmsData?.data?.attributes?.GeneralImage_Handset,
                  key: 'handset404Pagebg',
                  view: 'MobileViewImage',
                }).url
              }) center/cover no-repeat`,
            backgroundColor: theme.palette.secondary.contrastText,
            minHeight: '100vh',
            pl: '0 !important',
            pr: '0 !important',
          }}
        >
          <EirHandsetContainer
            title={title}
            cmsData={cmsData}
            onPortingChange={onPortingChange}
            offers={state.offers}
            discounts={state.discounts}
            onOfferSelect={onOfferSelect}
            onOfferUnSelect={onOfferUnSelect}
            addingTariff={addingTariff}
            selectedOfferId={state.selectedOfferId}
            loading={loading.offerData}
            selectedBundle={state.selectedMobileOffer}
            showLoader={showLoader}
            setHandsetCode={setHandsetCode}
            handsetCode={handsetCode}
            setShowLoader={setShowLoader}
            OutOfStockImg={`${publicRuntimeConfig.NEXT_PUBLIC_STRAPI}${
              getGeneralImage({
                generalImageArray: cmsData?.data?.attributes?.GeneralImage_Handset,
                key: 'outOfStockImage',
                view: 'MobileViewImage',
              }).url
            }`}
            OutOfStockImgAlt={
              getGeneralImage({
                generalImageArray: cmsData?.data?.attributes?.GeneralImage_Handset,
                key: 'outOfStockImage',
                view: 'MobileViewImage',
              }).alt
            }
            handsetNotFound={handsetNotFound}
            setHandsetNotFound={setHandsetNotFound}
            onPageLoadWhenVarientChanges={onPageLoadWhenVarientChanges}
            mobileOffersIncart={mobileOffersIncart}
            setMobileOffersIncart={setMobileOffersIncart}
            coUpgradeButton={coUpgradeButton}
            setShowInsurance={setShowInsurance}
            showInsurance={showInsurance}
            onPageLoad={onPageLoad}
          />
          {cmsData?.data?.attributes?.Handset_FAQ_List.length > 0 && (
            <Grid
              xs={12}
              sx={{
                background: theme.palette.primary.backgroundColor3,
                ...styles(theme).faqContainerSuperMain,
              }}
            >
              <FaqContainer
                InsuranceHeading={cmsData?.data?.attributes?.Handset_FAQ_Title}
                InsuranceList={cmsData?.data?.attributes?.Handset_FAQ_List}
              />
            </Grid>
          )}
        </Container>
        {openError && errorModalOccurence > errorModalMaxOccurence && (
          <ApiFailureModal openAPIFailureModal={openAPIFailureModal} handleOk={handleOk} />
        )}
        {showModal.value && <LoginMain403 />}
        {showSessionExpiredModal !== undefined && showSessionExpiredModal.value && (
          <SessionExpireModal confirmLogOut={showSessionExpiredModal} />
        )}
        {errorModal.value && !showModal.value && !showSessionExpiredModal.value && (
          <ErrorModal
            errorBBModal={errorModal}
            occurences={errorModalMaxOccurence}
            currentOccurence={errorModalOccurence}
            ctaMethod={onLoadError ? onPageLoad : () => {}}
          />
        )}
      </main>
      <EirFooter cmsFooterData={cmsFooterData?.data} />
    </>
  );
};

export default MobileDevice;
